import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';
export const AccountDetailHeaderSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();

  const borderRadius = theme.sk.radii.radiusRound;

  return (
    <View
      accessibilityLabel={i18n.t('sales_portal.account_detail.header.loading')}
      accessibilityRole="progressbar"
      style={styles.container}
    >
      <AnimatedSkeletonLoader
        borderRadius={borderRadius}
        height={24}
        width={150}
      />
      <AnimatedSkeletonLoader
        borderRadius={borderRadius}
        height={14}
        width={213}
      />
      <AnimatedSkeletonLoader
        borderRadius={borderRadius}
        height={14}
        width={99}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceSmall,
  },
}));
